import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Login from "./pages/Login";
import GravesList from "./pages/grave/GravesList";
import DepartedList from "./pages/departed/DepartedList";
import GraveDetails from "./pages/grave/GraveDetails";
import DepartedDetails from "./pages/departed/DepartedDetails";
import Layout from "./components/Layout";
import Missing from "./pages/Missing";
import RequireAuth from "./components/RequireAuth";
import Unauthorized from "./pages/Unauthorized";
import CementeryPathEditor from "./pages/Cementery/CementeryPathEditor";

const ROLES = {
  "Admin": 506,
  "User": 824
}

const App = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login/>}/>
      <Route path="/" element={<Layout/>}>
        <Route path="/unauthorized" element={<Unauthorized/>}/>
        <Route element={<RequireAuth allowedRoles={[ROLES.User]}/>}>
          <Route path="/" element={<Home/>}/>
          <Route path="/home" element={<Home/>}/>
          <Route path="/graves" element={<GravesList/>}/>
          <Route path="/departed" element={<DepartedList/>}/>
          <Route path="/gravedetails" element={<GraveDetails/>}/>
          <Route path="/departeddetails" element={<DepartedDetails/>}/>
          <Route path="/cementerypatheditor" element={<CementeryPathEditor/>}/>
        </Route>
        <Route path="*" element={<Missing/>}/>
      </Route>
    </Routes>
  );
};

export default App;
